import { useNavigate, useLocation } from "react-router-dom";
import { Building2, Car, Bike, Wrench, Hammer } from "lucide-react";
import { CATEGORIES } from "@/data/categories";

const ICONS = { Building2, Car, Bike, Wrench, Hammer };

export default function CategoryBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeSlug = location.pathname.startsWith("/v/")
    ? location.pathname.split("/v/")[1].split("/")[0]
    : (location.pathname.startsWith("/vertical/")
      ? location.pathname.split("/vertical/")[1]
      : (location.pathname.startsWith("/motors") ? "motors"
        : (location.pathname === "/" || location.pathname.startsWith("/properties") || location.pathname.startsWith("/agents") ? "property" : null)));

  return (
    <div className="bg-white border-b border-slate-200 sticky top-16 z-40" data-testid="category-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex items-center gap-2 overflow-x-auto no-scrollbar py-2.5">
          {CATEGORIES.map((c) => {
            const Icon = ICONS[c.icon];
            const active = activeSlug === c.slug;
            return (
              <button
                key={c.slug}
                data-testid={`cat-switch-${c.slug}`}
                onClick={() => navigate(c.live ? c.to : `/vertical/${c.slug}`)}
                className={`flex items-center gap-2 shrink-0 px-4 py-2 rounded-full text-sm font-semibold transition-colors border ${
                  active
                    ? "bg-navy text-white border-navy"
                    : "bg-white text-slate-600 border-slate-200 hover:border-navy hover:text-navy"
                }`}
              >
                <Icon className="h-4 w-4" />
                {c.label}
                {!c.live && (
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${active ? "bg-white/20 text-white" : "bg-gold/15 text-gold-dark"}`}>
                    SOON
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
